module.exports = __webpack_public_path__ + "media/images/index/area/faeture_hokkaido-ab1512dcccbb957169489a70e0b95099.png";